const externalDomain = process.env.NEXT_PUBLIC_EXTERNAL_DOMAIN
const externalPath = process.env.NEXT_PUBLIC_EXTERNAL_PATH

export const sortByKeyAndOrder = (key: string, order = 'asc') => {
  return function innerSort(a: any, b: any) {
    if (!Object.hasOwn(a, key) || !Object.hasOwn(b, key)) {
      return 0
    }

    const comparison = a[key].localeCompare(b[key])

    return order === 'desc' ? comparison * -1 : comparison
  }
}

export const getYear = () => {
  let yearPayment = []
  let year = new Date().getFullYear()

  for (let i = year; i <= year + 10; i += 1) {
    //@ts-ignore
    yearPayment[i] = {
      text: i,
    }
    //@ts-ignore
    yearPayment.push(yearPayment)
  }
  return yearPayment
}

export const years = (minYear = 1990) => {
  let yearsArray = []
  let i = new Date().getFullYear()
  let j = 1
  for (i; i >= minYear; i--) {
    //@ts-ignore
    yearsArray.push({ id: j, year: i })
    j++
  }

  return yearsArray
}

export const getHref = (path: string, hasExternalPath?: boolean) => {
  let href = externalDomain || 'https://www.enuygun.com'

  if (hasExternalPath) {
    href = `${href}${externalPath}${path}`
  } else {
    href = `${href}${path}`
  }

  return href
}

export const monthPayment = [
  {
    text: '01',
  },
  {
    text: '02',
  },
  {
    text: '03',
  },
  {
    text: '04',
  },
  {
    text: '05',
  },
  {
    text: '06',
  },
  {
    text: '07',
  },
  {
    text: '08',
  },
  {
    text: '09',
  },
  {
    text: '10',
  },
  {
    text: '11',
  },
  {
    text: '12',
  },
]

export const dateParser = (dateString: string) => {
  return new Date(`${dateString.replaceAll(' ', 'T')}Z`).toLocaleDateString('tr-TR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}

/**
 * Parse the given date string using by the locale (tr) or full locale (tr-tr) value.
 *
 * @param string dateString
 * @param string locale - default: tr
 * @returns Date string
 */
export const localeDateStringParser = (dateString: string, locale = 'tr') => {
  const _locale = locale.split('-')?.[1] || locale

  return new Date(dateString).toLocaleDateString(_locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}

export const organizeDataIntoGroups = (data, line) => {
  const groupedData = []

  if (!data || data?.length === 0) return groupedData

  for (let i = 0; i < data.length; i += line) {
    //@ts-ignore
    groupedData.push(data.slice(i, i + line))
  }
  return groupedData
}

export const replaceUnderscoreWithDash = (value: string): string => {
  return value?.replaceAll('_', '-')
}
